var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15636_7101)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15636_7101)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.05469 0.818848H25.8871V17.1825H1.05469V0.818848Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.77539 5.84424L6.42677 2.38579L7.05513 2.75035L4.40375 6.20879L3.77539 5.84424ZM4.71793 6.39107L7.36931 2.93262L7.99767 3.29718L5.34629 6.75562L4.71793 6.39107ZM5.66047 6.9379L8.31185 3.47946L8.94022 3.84401L6.28884 7.30245L5.66047 6.9379Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0551 14.2543L18.8379 12.3752L19.0633 12.0792L22.2805 13.9583L22.0551 14.2543Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.58594 6.83203C10.2967 5.9038 11.3812 5.24765 12.601 5.00792C13.8208 4.76819 15.0759 4.96452 16.0902 5.55372C17.1045 6.14292 17.7949 7.07673 18.0096 8.14972C18.2242 9.22271 17.9455 10.347 17.2348 11.2752L9.58594 6.83203Z",
  fill: "#CD2E3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.67258 6.77508C8.96481 7.69869 8.68727 8.81737 8.90104 9.88502C9.11481 10.9527 9.80237 11.8818 10.8125 12.4681C11.8226 13.0544 13.0724 13.2497 14.2872 13.0112C15.5019 12.7727 16.5819 12.1198 17.2897 11.1962C17.6436 10.7344 17.7824 10.175 17.6755 9.64119C17.5686 9.10736 17.2248 8.64278 16.7198 8.34964C16.2147 8.05651 15.5898 7.95883 14.9824 8.0781C14.3751 8.19737 13.835 8.52381 13.4811 8.98562L9.67258 6.77508Z",
  fill: "#0047A0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4208 8.97182C14.1553 8.01349 13.901 6.74349 12.8527 6.13518C11.8045 5.52688 10.3593 5.81062 9.62484 6.76895C8.89035 7.72727 9.14467 8.99728 10.1929 9.60558C11.2411 10.2139 12.6863 9.93014 13.4208 8.97182Z",
  fill: "#CD2E3A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.97148 13.0269L6.00391 13.5935L5.77791 13.296L6.74549 12.7293L6.97148 13.0269ZM20.195 5.28309L19.0662 5.94415L18.8402 5.6466L19.969 4.98554L20.195 5.28309ZM22.1302 4.14986L21.1626 4.71648L20.9366 4.41893L21.9042 3.85231L22.1302 4.14986Z",
  fill: "white"
})));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15636_7101"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15636_7101"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818115)"
})));
function SvgKo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.c29c7990.svg";
export { ForwardRef as ReactComponent };